import React from 'react';
import { FadeIn } from './FadeIn';
import { AlertOctagon } from 'lucide-react';
import { motion } from 'framer-motion';
export function CostSection() {
  const costs = [{
    situation: '3 hs semanales buscando qué publicar',
    cost: '144 horas al año'
  }, {
    situation: 'Sin imágenes IA',
    cost: 'Fotos amateur que bajan tu precio'
  }, {
    situation: 'Sin scripts de venta',
    cost: 'Consultas perdidas'
  }, {
    situation: 'Sin sistema de anuncios',
    cost: 'Plata tirada en publicidad'
  }, {
    situation: 'Sin método de 15 min',
    cost: 'Domingos perdidos en el celular'
  }];
  return <section className="py-8 md:py-16 px-4 max-w-5xl mx-auto" data-id="element-54">
      <FadeIn data-id="element-55">
        <div className="text-center mb-6 md:mb-14" data-id="element-56">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 rounded-full bg-[#b91c1c]/10 mb-3 md:mb-6 border border-[#b91c1c]/20" data-id="element-57">
            <span className="text-3xl md:text-5xl drop-shadow-[0_0_15px_rgba(185,28,28,0.2)]" data-id="element-58">
              ⚖️
            </span>
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-[#1a1611] mb-2 md:mb-4 px-2" data-id="element-59">
            ¿CUÁNTO CUESTA NO TENERLO?
          </h2>
          <p className="text-sm md:text-xl text-[#6b5d4f] font-bold" data-id="element-60">
            El precio de improvisar.
          </p>
        </div>
      </FadeIn>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-6" data-id="element-61">
        {costs.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-62">
            <motion.div whileHover={{
          scale: 1.02
        }} className="bg-white border border-[#e8dfd0] hover:border-[#b91c1c]/50 rounded-2xl p-4 md:p-6 flex flex-col justify-between h-full group relative overflow-hidden shadow-sm hover:shadow-md transition-all" data-id="element-63">
              <div className="absolute top-0 right-0 w-32 h-32 bg-[#b91c1c]/5 rounded-full blur-2xl -translate-y-1/2 translate-x-1/2 group-hover:bg-[#b91c1c]/10 transition-colors" data-id="element-64"></div>

              <p className="text-sm md:text-base text-[#1a1611] font-bold mb-3 md:mb-4 relative z-10" data-id="element-65">
                {item.situation}
              </p>

              <div className="flex items-center gap-2 md:gap-3 bg-[#b91c1c]/5 p-3 md:p-4 rounded-xl border border-[#b91c1c]/10 relative z-10" data-id="element-66">
                <AlertOctagon className="text-[#b91c1c] shrink-0 w-5 h-5 md:w-6 md:h-6" data-id="element-67" />
                <span className="font-black text-[#b91c1c] text-sm md:text-lg leading-tight" data-id="element-68">
                  {item.cost}
                </span>
              </div>
            </motion.div>
          </FadeIn>)}
      </div>
    </section>;
}